/*global $:false */

import tmpl_form from '../templates/search-simple-form.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// $container: the jquery HTML wrapper for the enclosing element
//
// confs
//
// * `advance-search`: if the advance search is to be enabled
//
// callbacks:
//
// * `doSearch`: called when the user clicks the new search button or presses enter
// * `filterChanged`: when the search filter changed his state
// * `showAdvancedSearch` : The user requested the advance search
var SimpleSearchV = function(core, $container, entityM, simpleSearchM, confs, callbacks) {

    var _$searchFormContainer = $(".js-search-form-container", $container),
        _$searchForm = $(tmpl_form({entityM: entityM, simpleSearchM})),
        _$searchField = $(".js-search-field", _$searchForm),
        _$advancedSearchLink = $(".js-advanced-search-link", _$searchForm),
        _$filterToggle = $(".js-search-filter-toggle", _$searchForm);

    var _initialQuery;

    var _confs = {"advance-search": true};

    var _addListenerToGoToAdvancedSearch = function() {
        _$advancedSearchLink.click(function() {
            callbacks.showAdvancedSearch();
        });
    };

    var _addListenerToFilterToggle = function() {
        _$filterToggle.on('change', function(ev) {
            const selectedLabels = _$filterToggle.map(function(idx, el) {
                const _$el = $(el)
                return {
                    label: _$el.data("label"),
                    selected: _$el.prop('checked'),
                    defaultValue: _$el.data('default-value')
                }
            }).toArray()

            const _$thisElement = $(ev.target)
            const value = _$thisElement.prop('checked')
            // revert the change in the checkbox so that the state of the form is correct when
            // we navigate back. Notice that for each change in a filter we are sending the user
            // to a new state
            _$thisElement.prop('checked', !value)

            callbacks.filterChanged(selectedLabels);
        });
    };

    (function init() {

        utils.extend(_confs, confs, true);

        core.translate("recordm.search", _$searchForm);

        if (entityM) {
            _addListenerToGoToAdvancedSearch();
        }

        if (!_confs["advance-search"]) {
            _$advancedSearchLink.remove();
        }

        $container.on('submit', '.js-form-search', function(e) {
            e.preventDefault();

            const newQuery = _$searchField.val().trim();
            // we reset the input, it will be correctly filled after navigation
            // and if we navigate back we expect to see the initial query
            _$searchField.val(_initialQuery);

            callbacks.doSearch(newQuery);
        });

        _addListenerToFilterToggle();
    })();

    return {
        start: function() {
            _$searchFormContainer.html(_$searchForm);
        },
        stop: function() {
            _$searchForm.detach();
        },
        destroy: function() {
            $container.off('submit', '.js-form-search');
            _$searchForm.remove();
        },
        setSearchQuery: function(query) {
            _initialQuery = query;
            _$searchField.val(query);
        },
        resetSearchField: function() {
            _$searchField.val("");
        },
        setFocusOnSearch: function() {
            _$searchField.focus();
            // In Firefox if you focus a text input element the cursor stays at the beggining of the text instead of
            // the end. We set the value afterwards to move it to the end.
            var value = _$searchField.val();
            _$searchField.val('');
            _$searchField.val(value);
        }
    };
};

export default SimpleSearchV;
